// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Time40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Time40: FC<Time40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
            viewBox="0 0 40 40"
        >
            <path d="m25.28 27.52 2.24-2.24-5.92-5.92V12h-3.2v8.64zM20 36q-3.32 0-6.24-1.26t-5.08-3.42q-2.16-2.16-3.42-5.08T4 20q0-3.32 1.26-6.24t3.42-5.08q2.16-2.16 5.08-3.42T20 4q3.32 0 6.24 1.26t5.08 3.42q2.16 2.16 3.42 5.08T36 20q0 3.32-1.26 6.24t-3.42 5.08q-2.16 2.16-5.08 3.42T20 36m0-3.2q5.32 0 9.06-3.74T32.8 20q0-5.32-3.74-9.06T20 7.2q-5.32 0-9.06 3.74T7.2 20q0 5.32 3.74 9.06T20 32.8" />
        </svg>
    );
};

export default Time40;
